import { getHolders } from '@cronos-app/api';
import { BONDING_TOKEN_DECIMALS, type ExplicitAddress } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { useQuery } from '@tanstack/react-query';
import { useSDK } from '@ui/utils';
import { Fraction } from 'bi-fraction';

import { useGlobalChainLayer } from '../useGlobalChainLayer';

export interface Holder {
  address: string;
  userName: string;
  percent: Fraction;
  amount: Fraction;
}

export interface HolderRes {
  totalHolder: number;
  holders: Holder[];
}

export const useAgentHolderInfo = (
  tokenAddress: ExplicitAddress | undefined | null,
) => {
  const chainLayer = useGlobalChainLayer();
  const myAccount = currentWallet.useAccount() ?? '';
  const sdk = useSDK();

  return useQuery<HolderRes>({
    queryKey: ['useAgentHolders', tokenAddress, sdk, myAccount, chainLayer],
    queryFn: async () => {
      if (!tokenAddress) throw new Error('tokenAddress is empty');

      const holders = await getHolders(chainLayer, tokenAddress);

      return {
        totalHolder: holders.total_holders,
        holders: holders.top_holders.map((item) => {
          return {
            address: item.address,
            userName: item.name,
            percent: Fraction.tryParse(item.percentage) ?? Fraction.ZERO,
            amount: new Fraction(item.balance).shr(BONDING_TOKEN_DECIMALS),
          };
        }),
      };
    },
    enabled: !!tokenAddress,
  });
};
